import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
	(
		<Suspense fallback={<SuspenseLoader />}>
			<Component {...props} />
		</Suspense>
	);

const InvoiceAdmin = Loader(lazy(() => import('src/invoice/InvoiceAdmin')));
const PublicPayPage = Loader(lazy(() => import('src/invoice/PublicPayPage')));

// The admin dashboard guards itself with its own login card; /pay/:invoiceId
// is the shareable customer payment page and must stay auth-free.
const routes: RouteObject[] = [
	{
		path: '/',
		element: <InvoiceAdmin />
	},
	{
		path: 'pay/:invoiceId',
		element: <PublicPayPage />
	},
	{
		path: '*',
		element: <Navigate to="/" replace />
	}
];

export default routes;
